import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Translate } from './shared';
import { TranslatePlaceholder} from './shared';
import { TranslateElem } from '../shared/shared';
import { TranslateWord } from '../shared/shared';
import { TranslateHidden } from './translate';
import { OfflineModeWarning } from './offlineMode.component';

@NgModule({
    declarations: [
        Translate,
        TranslatePlaceholder,
        TranslateHidden,
        TranslateElem,
        TranslateWord,
        OfflineModeWarning,
    ],
    imports: [],
    providers: [],
    exports: [
        Translate,
        TranslatePlaceholder,
        TranslateHidden,
        TranslateElem,
        TranslateWord,
        OfflineModeWarning,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
